import { useCallback } from 'react';

import { useAppDispatch } from 'store';
import { addAlert } from 'store/slices/alerts';

const useAlertQueue = () => {
  const dispatch = useAppDispatch();

  const addSuccessAlert = useCallback(
    (title: string, body: string) => dispatch(addAlert({ type: 'success', title, body })),
    [dispatch]
  );

  const addErrorAlert = useCallback(
    (title: string, body: string) => dispatch(addAlert({ type: 'error', title, body })),
    [dispatch]
  );

  const addWarningAlert = useCallback(
    (title: string, body: string, options: { bodyLineClamp?: number; persistent?: boolean } = {}) =>
      dispatch(addAlert({ type: 'warning', title, body, ...options })),
    [dispatch]
  );

  return { addSuccessAlert, addErrorAlert, addWarningAlert };
};

export default useAlertQueue;
